import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, Route, Switch, useHistory, useLocation } from "react-router-dom";

import { EmailSignUp } from "../../Components/SignUp/Email";
import { VerifySignUp } from "../../Components/SignUp/Verify";
import { PasswordSignUp } from "../../Components/SignUp/Password";
import { DetailsSignUp } from "../../Components/SignUp/Details";
import { SubscriptionSignUp } from "../../Components/SignUp/Subscription";
import { Stripe } from "../../Components/SignUp/Stripe";
import { useDispatch } from "react-redux";
import { showToast } from "../../Store/Actions/ToastActions";

export const SignUp = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <section className={`signup`}>
      <Helmet>
        <title>Sign Up | Wazoo</title>
      </Helmet>
      <nav className="signup__navigation">
        <div className="left">
          <div className="logo">
            <svg
              width="143"
              height="40"
              viewBox="0 0 143 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="3"
                width="34"
                height="34"
                rx="8.85339"
                fill="#1E3E23"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.7694 20.0234C31.7694 20.0157 31.7694 20.0079 31.7694 20.0002C31.7694 13.5002 26.5002 8.23096 20.0002 8.23096C13.5002 8.23096 8.23096 13.5002 8.23096 20.0002C8.23096 26.5002 13.5002 31.7694 20.0002 31.7694C23.6973 31.7694 26.9963 30.0647 29.154 27.3983V36.9649C30.4765 36.8405 31.0517 36.6034 31.848 36.2726L31.7694 20.0234Z"
                fill="white"
              />
              <path
                d="M23.9835 19.4872C23.9835 21.2777 21.586 24.4652 20.5348 25.7804C20.2827 26.0939 19.8155 26.0939 19.5635 25.7804C18.4938 24.4652 16.1147 21.2777 16.1147 19.4872C16.1147 17.3149 17.8762 15.554 20.0491 15.554C22.2213 15.554 23.9835 17.3149 23.9835 19.4872Z"
                fill="#1E3E23"
              />
              <path
                d="M48.2148 11.21H51.9316L56.4863 22.0488L57.5391 24.6699L58.3662 22.0488L60.042 18.0957L57.0234 11.21H60.5254L61.7607 14.4863L62.9102 11.21H66.4121L63.3936 18.0957L65.1016 22.1348L66.1328 24.6699L66.9277 22.0918L71.5039 11.21H75.2207L67.8086 28H64.4355L62.9424 24.6699L61.7285 21.4365L60.5146 24.6699L59 28H55.627L48.2148 11.21ZM76.3373 24.0039C76.3373 23.3952 76.4698 22.8402 76.7348 22.3389C76.9997 21.8376 77.3972 21.4079 77.9271 21.0498C78.4571 20.6846 79.1159 20.4053 79.9037 20.2119C80.6986 20.0114 81.6224 19.9111 82.6752 19.9111C83.4558 19.9111 84.2758 19.9684 85.1351 20.083C86.0017 20.1976 86.8933 20.373 87.8099 20.6094C87.7741 20.2083 87.6524 19.8395 87.4447 19.5029C87.237 19.1592 86.947 18.8656 86.5746 18.6221C86.2094 18.3714 85.7653 18.1781 85.2426 18.042C84.7269 17.9059 84.1397 17.8379 83.4808 17.8379C83.1228 17.8379 82.7289 17.8594 82.2992 17.9023C81.8695 17.9453 81.4255 18.0098 80.9672 18.0957C80.5088 18.1816 80.0541 18.2891 79.6029 18.418C79.1589 18.5469 78.7435 18.7008 78.3568 18.8799L77.39 16.2695C77.8698 16.0977 78.3819 15.9401 78.9262 15.7969C79.4776 15.6536 80.0398 15.5319 80.6127 15.4316C81.1856 15.3242 81.7585 15.2419 82.3314 15.1846C82.9043 15.1273 83.4594 15.0986 83.9965 15.0986C86.3669 15.0986 88.1286 15.7038 89.2816 16.9141C90.4346 18.1243 91.0111 19.9792 91.0111 22.4785V28H87.8314V26.8076C87.502 27.001 87.1403 27.1836 86.7465 27.3555C86.3598 27.5273 85.9372 27.6777 85.4789 27.8066C85.0206 27.9355 84.5264 28.0358 83.9965 28.1074C83.4737 28.1862 82.9187 28.2256 82.3314 28.2256C81.3431 28.2256 80.473 28.1182 79.7211 27.9033C78.9763 27.6885 78.3532 27.3913 77.8519 27.0117C77.3506 26.6322 76.9711 26.1882 76.7133 25.6797C76.4626 25.1641 76.3373 24.6055 76.3373 24.0039ZM79.6889 23.8965C79.6889 24.1042 79.7426 24.3047 79.85 24.498C79.9574 24.6842 80.1293 24.8525 80.3656 25.0029C80.6019 25.1462 80.9027 25.2643 81.268 25.3574C81.6403 25.4434 82.0879 25.4863 82.6107 25.4863C83.1693 25.4863 83.71 25.4362 84.2328 25.3359C84.7556 25.2357 85.2426 25.1032 85.6937 24.9385C86.1449 24.7738 86.5531 24.584 86.9183 24.3691C87.2836 24.1543 87.5879 23.9323 87.8314 23.7031V23.1445C87.3445 23.0085 86.8611 22.8939 86.3812 22.8008C85.9086 22.7077 85.4538 22.6361 85.017 22.5859C84.5873 22.5286 84.1791 22.4893 83.7924 22.4678C83.4128 22.4463 83.0798 22.4355 82.7933 22.4355C82.1989 22.4355 81.7048 22.4749 81.3109 22.5537C80.917 22.6325 80.5984 22.7399 80.3549 22.876C80.1114 23.0049 79.9395 23.1589 79.8392 23.3379C79.739 23.5169 79.6889 23.7031 79.6889 23.8965ZM100.85 17.9668H94.3513V15.3242H106.748L98.9275 25.3574H106.318V28H93.0838L100.85 17.9668ZM108.144 21.6621C108.144 20.7526 108.326 19.9004 108.692 19.1055C109.064 18.3105 109.59 17.6159 110.271 17.0215C110.958 16.4271 111.785 15.958 112.752 15.6143C113.726 15.2705 114.818 15.0986 116.028 15.0986C117.239 15.0986 118.327 15.2705 119.294 15.6143C120.268 15.958 121.095 16.4271 121.776 17.0215C122.463 17.6159 122.989 18.3105 123.355 19.1055C123.727 19.9004 123.913 20.7526 123.913 21.6621C123.913 22.5716 123.727 23.4238 123.355 24.2188C122.989 25.0137 122.463 25.7083 121.776 26.3027C121.095 26.8971 120.268 27.3662 119.294 27.71C118.327 28.0537 117.239 28.2256 116.028 28.2256C114.818 28.2256 113.726 28.0537 112.752 27.71C111.785 27.3662 110.958 26.8971 110.271 26.3027C109.59 25.7083 109.064 25.0137 108.692 24.2188C108.326 23.4238 108.144 22.5716 108.144 21.6621ZM111.485 21.6621C111.485 22.1706 111.585 22.654 111.785 23.1123C111.993 23.5635 112.29 23.9645 112.677 24.3154C113.071 24.6592 113.547 24.9349 114.106 25.1426C114.671 25.3431 115.312 25.4434 116.028 25.4434C116.745 25.4434 117.382 25.3431 117.941 25.1426C118.506 24.9349 118.983 24.6592 119.369 24.3154C119.763 23.9645 120.06 23.5635 120.261 23.1123C120.469 22.654 120.572 22.1706 120.572 21.6621C120.572 21.1536 120.469 20.6702 120.261 20.2119C120.06 19.7536 119.763 19.3525 119.369 19.0088C118.983 18.6579 118.506 18.3822 117.941 18.1816C117.382 17.974 116.745 17.8701 116.028 17.8701C115.312 17.8701 114.671 17.974 114.106 18.1816C113.547 18.3822 113.071 18.6579 112.677 19.0088C112.29 19.3525 111.993 19.7536 111.785 20.2119C111.585 20.6702 111.485 21.1536 111.485 21.6621ZM125.878 21.6621C125.878 20.7526 126.061 19.9004 126.426 19.1055C126.799 18.3105 127.325 17.6159 128.005 17.0215C128.693 16.4271 129.52 15.958 130.487 15.6143C131.461 15.2705 132.553 15.0986 133.763 15.0986C134.974 15.0986 136.062 15.2705 137.029 15.6143C138.003 15.958 138.83 16.4271 139.51 17.0215C140.198 17.6159 140.724 18.3105 141.089 19.1055C141.462 19.9004 141.648 20.7526 141.648 21.6621C141.648 22.5716 141.462 23.4238 141.089 24.2188C140.724 25.0137 140.198 25.7083 139.51 26.3027C138.83 26.8971 138.003 27.3662 137.029 27.71C136.062 28.0537 134.974 28.2256 133.763 28.2256C132.553 28.2256 131.461 28.0537 130.487 27.71C129.52 27.3662 128.693 26.8971 128.005 26.3027C127.325 25.7083 126.799 25.0137 126.426 24.2188C126.061 23.4238 125.878 22.5716 125.878 21.6621ZM129.219 21.6621C129.219 22.1706 129.32 22.654 129.52 23.1123C129.728 23.5635 130.025 23.9645 130.412 24.3154C130.806 24.6592 131.282 24.9349 131.84 25.1426C132.406 25.3431 133.047 25.4434 133.763 25.4434C134.479 25.4434 135.117 25.3431 135.675 25.1426C136.241 24.9349 136.717 24.6592 137.104 24.3154C137.498 23.9645 137.795 23.5635 137.996 23.1123C138.203 22.654 138.307 22.1706 138.307 21.6621C138.307 21.1536 138.203 20.6702 137.996 20.2119C137.795 19.7536 137.498 19.3525 137.104 19.0088C136.717 18.6579 136.241 18.3822 135.675 18.1816C135.117 17.974 134.479 17.8701 133.763 17.8701C133.047 17.8701 132.406 17.974 131.84 18.1816C131.282 18.3822 130.806 18.6579 130.412 19.0088C130.025 19.3525 129.728 19.7536 129.52 20.2119C129.32 20.6702 129.219 21.1536 129.219 21.6621Z"
                fill="#1E3E23"
              />
            </svg>
          </div>
          <div className="mobile-logo">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3.00293"
                y="3.00293"
                width="34"
                height="34"
                rx="8.70012"
                fill="#1E3E23"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M31.7723 20.0471C31.7723 20.0324 31.7723 20.0178 31.7723 20.0031C31.7723 13.5031 26.5031 8.23389 20.0031 8.23389C13.5031 8.23389 8.23389 13.5031 8.23389 20.0031C8.23389 26.5031 13.5031 31.7723 20.0031 31.7723C23.7002 31.7723 26.9991 30.0677 29.1567 27.4014V36.9678C30.4793 36.8434 31.0545 36.6063 31.8507 36.2755L31.7723 20.0471Z"
                fill="white"
              />
              <path
                d="M23.9865 19.4899C23.9865 21.2803 21.5889 24.4679 20.5377 25.7831C20.2857 26.0965 19.8185 26.0965 19.5664 25.7831C18.4968 24.4679 16.1177 21.2803 16.1177 19.4899C16.1177 17.3176 17.8791 15.5566 20.0521 15.5566C22.2242 15.5566 23.9865 17.3176 23.9865 19.4899Z"
                fill="#1E3E23"
              />
            </svg>
          </div>
        </div>
        <div className="right">
          <span>
            {localStorage.getItem("userToken") ? (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  localStorage.removeItem("userToken");
                  dispatch(
                    showToast({
                      title: "Success",
                      text: "Log out success",
                      type: "success",
                    })
                  );
                  history.push("/login");
                }}
              >
                Log out
              </span>
            ) : (
              <>
                Already a member?<Link to={"/login"}>Sign in</Link>
              </>
            )}
          </span>
        </div>
      </nav>
      <div className="signup__content">
        <div className="signup__left">
          {location?.pathname === "/signup/stripe" ? (
            <img src="/assets/images/payment-sidebar.svg" alt="" />
          ) : <img src="/assets/images/signup_sidebar.svg" alt="" /> &&
            location?.pathname === "/signup/subscription" ? (
            <img src="/assets/images/pricing_sidebar.svg" alt="" />
          ) : (
            <img src="/assets/images/signup_sidebar.svg" alt="" />
          )}
        </div>
        <div className="signup__right">
          <Switch>
            <Route exact path="/signup" component={EmailSignUp} />
            <Route exact path="/signup/code" component={VerifySignUp} />
            <Route exact path="/signup/password" component={PasswordSignUp} />
            <Route exact path="/signup/details" component={DetailsSignUp} />
            <Route
              exact
              path="/signup/subscription"
              component={SubscriptionSignUp}
            />
            <Route exact path="/signup/card" component={Stripe} />
          </Switch>
        </div>
      </div>
    </section>
  );
};
